import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const UserIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 14 16" {...props}>
      <path
        fill={fill}
        d="M163.545455,1583 C161.541453,1583 159.909091,1584.63236 159.909091,1586.63636 C159.909091,1588.64037 161.541453,1590.27273 163.545455,1590.27273 C165.549455,1590.27273 167.181818,1588.64037 167.181818,1586.63636 C167.181818,1584.63236 165.549455,1583 163.545455,1583 Z M162.090909,1591.36364 C160.354559,1591.36364 159.08285,1591.51474 158.210227,1592.24432 C157.337605,1592.97388 157,1594.20515 157,1596.09091 L157,1598.63636 C157,1598.82676 157.173242,1599 157.363636,1599 C161.484849,1599 165.606061,1599 169.727273,1599 C169.917667,1599 170.090909,1598.82676 170.090909,1598.63636 L170.090909,1596.09091 C170.090909,1594.20515 169.753305,1592.97388 168.880682,1592.24432 C168.008059,1591.51474 166.736351,1591.36364 165,1591.36364 C163.771124,1591.36235 162.868603,1591.36358 162.090909,1591.36364 Z"
        transform="translate(-157, -1583)"
      />
    </Icon>
  );
};

UserIcon.propTypes = {
  fill: PropTypes.string,
};

export default UserIcon;
